export const TOGGLE_STRATEGY_SIDEBAR = "TOGGLE_STRATEGY_SIDEBAR";
export const SET_ACTIVE_KEY = "SET_ACTIVE_KEY";